import { useState, useEffect } from "react";

/**
 * Hook para debouncing de valores (ex: busca).
 * @param value Valor a ser "debounced"
 * @param delay Delay em ms (padrão: 300)
 */
export function useDebouncedValue<T>(value: T, delay = 300): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(handler);
  }, [value, delay]);

  return debounced;
}